import { NotFoundException } from '@nestjs/common';

export class UserNotFoundException extends NotFoundException {
  /**
   * @param identifier id | email
   */
  constructor(identifier: string) {
    super(`User not found: ${identifier}`);
  }
}
